import React from 'react'
import type { useAddAdditionalWorkPanelStyles } from './useAddAdditionalWorkPanelStyles'

interface DividerRowProps {
  classes: ReturnType<typeof useAddAdditionalWorkPanelStyles>
}

export default function DividerRow({ classes }: DividerRowProps) {
  return (
    <div className={classes.divider}>
      <div className={classes.dividerLine} />
      <span className={classes.dividerText}>or</span>
      <div className={classes.dividerLine} />
    </div>
  )
}
